import MobileLockIcon from './MobileLockIcon'

export default MobileLockIcon
